import { render, staticRenderFns } from "./KdmvpCanvas.vue?vue&type=template&id=58e7a5a0&scoped=true&"
import script from "./KdmvpCanvas.vue?vue&type=script&lang=js&"
export * from "./KdmvpCanvas.vue?vue&type=script&lang=js&"
import style0 from "./KdmvpCanvas.vue?vue&type=style&index=0&id=58e7a5a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e7a5a0",
  null
  
)

export default component.exports